import useTranslation from 'next-translate/useTranslation'

import BodyText from '../../../app/components/BodyText'
import useAppSelector from '../../../../store/hooks/useAppSelector'
import { clientContextIsCompanyUserSelector } from '../../../clientContext/store/clientContextSelectors'
import CompanyProfileNudge from '../../../company/components/CompanyProfileNudge'
import { GuestOrderHorizonDays } from '../../../preOrder/constants'

import styles from './PrivateScheduleHint.module.scss'

type PrivateScheduleHintProps = {
  /** Called after switching to a company profile */
  onSwitchedToCompany?: () => void
}

/**
 * Hint in the private time picker: how far ahead a private order can
 * go, and for members of a company, the company nudge
 */
export default function PrivateScheduleHint({
  onSwitchedToCompany,
}: PrivateScheduleHintProps) {
  const { t } = useTranslation('common')

  const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector)

  if (isCompanyUser) {
    return null
  }

  return (
    <div className={styles.container}>
      <BodyText as="p" color="body-1">
        {t('startOrder.privateHorizon', { days: GuestOrderHorizonDays })}
      </BodyText>
      <CompanyProfileNudge onSwitched={onSwitchedToCompany} />
    </div>
  )
}
